import { styled } from "@mui/material";

export const ContainerDetailStyled = styled("div")(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  borderRadius: "8px",
  backgroundColor: "#F5F5F5",
  padding: "16px",
  width: "100%",
}));

export const ContainerInfoLineStyled = styled("div")(() => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  justifyContent: "space-between",
}));
